<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Approve User</mat-card-title>
            </mat-card-header>

            <mat-card-content style="padding-left: 16px;">

              <p>Use the form below to make any final changes before approving the user. Click APPROVE when ready to approve.</p>

              <!-- user details column -->
              <div  style="display: inline-block; width: 350px;">

                <div style="margin-bottom: 24px;">

                  <p-avatar style="display: inline-block;" image="{{profilePicture()}}" class="useravatar" size="xlarge"></p-avatar>

                  <h3 style="display: inline-block;vertical-align: top;margin-top: 10px;margin-left: 12px;">User Details</h3>

                </div>

                <div class="inputform" [formGroup]="form">

                  <!-- display_name -->

                  <span class="inputfloatlabelwrapper">

                    <p-floatlabel>

                      <input
                        pInputText
                        id="displayname"
                        formControlName="name"
                        required
                        type="text"
                        (change)="setName($event)"
                      />

                      <label for="displayname">Display Name</label>

                    </p-floatlabel>

                    <div class="inputerrorbox" *ngIf="name.invalid && name.dirty">

                      <small *ngIf="name.errors.required" class="p-error">
                        Display Name can not be empty.
                      </small>

                    </div>

                  </span>

                  <!-- first_name -->

                  <span class="inputfloatlabelwrapper">

                    <p-floatlabel>

                      <input
                        pInputText
                        id="firstname"
                        formControlName="firstname"
                        required
                        type="text"
                        (change)="setFirstName($event)"
                      />

                      <label for="firstname">First Name</label>

                    </p-floatlabel>

                    <div class="inputerrorbox" *ngIf="firstname.invalid && firstname.dirty">

                      <small *ngIf="firstname.errors.required"  class="p-error">
                        First Name can not be empty.
                      </small>

                    </div>

                  </span>

                  <!-- last_name -->

                  <span class="inputfloatlabelwrapper">

                    <p-floatlabel>

                      <input
                        pInputText
                        id="lastname"
                        formControlName="lastname"
                        required
                        type="text"
                        (change)="setLastName($event)"
                      />

                      <label for="lastname">Last Name</label>

                    </p-floatlabel>

                    <div class="inputerrorbox" *ngIf="lastname.invalid && lastname.dirty">

                      <small *ngIf="lastname.errors.required" class="p-error">
                        First Name can not be empty.
                      </small>

                    </div>

                  </span>

                  <!-- email -->

                  <span class="inputfloatlabelwrapper">

                    <p-floatlabel>

                      <input
                        pInputText
                        id="email"
                        formControlName="email"
                        required
                        type="text"
                        (change)="setEMail($event)"
                      />
                      <label for="email">eMail</label>

                    </p-floatlabel>

                    <div class="inputerrorbox" *ngIf="email.invalid && email.dirty">

                      <small *ngIf="email.errors.required"  class="p-error">
                        eMail can not be empty.
                      </small>

                      <small *ngIf="email.errors.pattern"  class="p-error">
                        Invalid email value
                      </small>

                      <small *ngIf="email.errors.exists"  class="p-error">
                        eMail is already in use by another account.
                      </small>

                    </div>

                  </span>

                  <!-- userid -->

                  <span class="inputfloatlabelwrapper">

                    <p-floatlabel>

                      <input
                        pInputText
                        id="userid"
                        formControlName="userid"
                        required
                        type="text"
                        (change)="setUserid($event)"
                      />

                      <label for="userid">Userid</label>

                    </p-floatlabel>

                    <div class="inputerrorbox" *ngIf="userid.invalid && userid.dirty">

                      <small *ngIf="userid.errors.required"  class="p-error">
                        Userid can not be empty.
                      </small>

                      <small *ngIf="userid.errors.pattern"  class="p-error">
                        Invalid userid value
                      </small>

                      <small *ngIf="userid.errors.exists"  class="p-error">
                        Userid is already in use by another account.
                      </small>

                    </div>

                  </span>

                  <div>

                    <label>Password (optional):</label>

                    <p-password
                      id="passwordforminput"
                      width="300"
                      toggleMask="true"
                      feedback="true"
                      formControlName="password"
                      [class.p-filled]="newUser && (_password.trim().length > 0)"
                      (change)="setPassword($event)">

                    </p-password>

                    <div style="width: 250px;">

                      <div>

                        <h6>Pick a password</h6>

                        <small>
                          <i>
                            The "direct" password is a useful backup for when SSO methods are not working.  Users also require
                            a direct password to authenticate with/use our REST API.  The direct password can always be reset
                            by using the User Edit screen (Admin &gt; Users &gt; [the user]).
                          </i>
                        </small>

                      </div>

                      <p-divider></p-divider>

                      <p class="p-mt-2">Suggestions</p>
                      <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                        <li>At least one lowercase</li>
                        <li>At least one uppercase</li>
                        <li>At least one numeric</li>
                        <li>Minimum 8 characters</li>
                      </ul>

                    </div>

                  </div>

                </div>

                <p-button type="button" label="Approve"  icon="pi pi-save" class="p-button-lg" [disabled]="!form.valid" (click)="save()"></p-button>

                <span id="savemsg" style="margin-left: 16px;">{{saveMessage}}</span>

              </div>

              <!-- organization admin column -->
              <div  style="display: inline-block; width: 350px;  vertical-align: top;">

                <div style="margin-bottom: 24px;">

                  <h3>Organizational Administrator?</h3>

                </div>

                <div class="approve-user-orgs-wrapper">

                  <div class="approve-user-org-row" *ngFor="let org of organizations">
                    <p-inputSwitch class="approve-user-org-switch" (onChange)="toggleOrgAdmin($event, org.key)"></p-inputSwitch>
                    <label class="approve-user-org-label">{{org.name}}</label>
                  </div>

                </div>


              </div>

            </mat-card-content>

          </mat-card>

        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>
  </div>

</div>
